<template>
  <div class="hello">
    <div v-if="banner.slider">
      <i-banner :sliders="banner.slider" height="514px" @changeLang="changeLang">
        <div class="baoming">
          <iButton @buttonBind="toggle" :text="bmText" icon-class="fa-pencil"></iButton>
        </div>
      </i-banner>
    </div>
    <!--导航-->
    <div v-if="navs && banner.slider" style="height: 50px;margin-top: -25px;">
      <i-nav @login="login" :navs="navs" :author="author"></i-nav>
    </div>
    <div class="container">
      <div v-for="(item,index) in lanmu">
        <div v-if="item.name && !item.baseInfo">
          <top-bar :id="item.id" style="padding:12px 0 12px 12px;border-bottom: 1px solid #ababab;margin-top: 32px;"
                   :text="item.name"></top-bar>
          <div v-if="item.defHtml" class="box-list" v-html="item.defHtml"></div>
        </div>

        <div :id="item.id" v-if="item.name && item.baseInfo">
          <base-info :language="language" :baseInfos="baseInfos" :oProvince="oProvince"></base-info>
        </div>

        <div v-if="item.teacher">
          <!--优秀讲者-->
          <i-teacher :dataInfo="teachers" col="4" spanCol="6"></i-teacher>
        </div>
        <div v-if="item.news.length>0">
          <!--优秀讲者-->
          <i-news :news="item.news"></i-news>
        </div>
      </div>
    </div>
    <i-brand v-if="banner.slider"></i-brand>
    <i-scan @scanClick="toggle" :activeScan="activeScan"></i-scan>
    <i-login @closeLogin="closeLogin" @loginUser="loginUser" :language="language" :flag="showLogin"></i-login>
  </div>
</template>
<script>
  import iBanner from '@/components/tpl1/iBanner'
  import iButton from '@/components/tpl1/iButton'
  import icon from '@/components/tpl1/icon'
  import topBar from '@/components/tpl1/topBar'
  import iTeacher from '@/components/tpl1/iTeacher'
  import iGuide from '@/components/tpl1/iGuide'
  import iBrand from '@/components/tpl1/iBrand'
  import iNav from '@/components/tpl1/iNav'
  import iScan from '@/components/tpl1/iScan'
  import iLogin from '@/components/tpl1/iLogin'
  import iNews from '@/components/tpl1/iNews'
  import baseInfo from '@/components/tpl1/baseInfo'
  import bg from '../imgs/aa.jpg'

  import avatar from '../imgs/avatar.jpg'
  export default {
    name: 'hello',
    data () {
      return {
        bmText: "点击报名",
        author: "登录",
        showLogin: false,
        activeScan: false,
        banner: {
          slider: ""
        },
//      导航数据结构
        navs: [],
//      新闻列表
        news: [],
        lanmu: [],
        baseInfos: [],
        oProvince: [],
//      会议简介
        mettingInfo: "",
        cCalendar: "",
        teachers: [],
//      参会指南
        cGuide: "",
        language: 0
      }
    },
    components: {
      iBanner, icon, topBar, iBrand, iTeacher, iGuide, iNav, iScan, iButton, iLogin, iNews, baseInfo
    },
    mounted(){
      let lang = window.navigator.language;
      this.language = 0;
      if (lang != 'zh-CN') {
        lang = "en";
        this.language = 1;
      } else {
        lang = 'cn';
        this.language = 0;
      }
      this.initData(lang);
    },
    methods: {
      initData(lang){
        //      检测语言
        axios.request({
          url: '/medapp/api/con/detail',
          method: 'post', // default
          data: {
            cid: 11,
            uid: 11
          },
          headers: {'language': lang}
        }).then((response) => {
//          console.log(response);
          let data = response.data;
          this.banner = {
            slider: response.data.slider
          };
//        console.log(response);
//        this.author = data.signuser.name;
          this.teachers = response.data.speaker.map((item) => {
            return {
              avatar: item.uIcon,
              name: item.uName,
              hospital: item.uOrg,
              position: "",
              description: item.uDesc
            }
          });
//        导航原始数据
          this.navs = response.data.template.navs.map((item, index) => {
            let linkTarget = "";
            if (item.navShow == 2) {
              linkTarget = "_self"
            } else if (item.navShow = 3) {
              linkTarget = "_blank"
            }
            return {
              navName: item.navName,
              navUrl: item.navUrl,
              navOrder: item.navOrder,
//              字符	def：自定义html片段     sys:系统内置模块  link:外链
              id: item.navType !== "link" ? "id_" + index : "",
              linkTarget: linkTarget,
              active: index === 0 ? true : false
            }
          });
          this.lanmu = response.data.template.navs.map((item, index) => {
            return {
//              模块的id
              id: item.navType !== "link" ? "id_" + index : "",
//            模块名字
              name: item.navType !== "link" ? item.navName : "",
//            如果是后台返回的html代码，
              dataString: item.navType == "def" ? item.navContent : "",
//            是否是基本信息
              baseInfo: item.navSys == "base",
//            专家简介
              teacher: item.navSys == "vip",
              defHtml: item.navType == "def" ? item.navContent : "",
              news: item.navSys === 'info' && item.infos ? item.infos : []
            }
          });
          this.baseInfos = [
            {
              title: ["开始时间", 'start time'],
              data: data.conference.cStart,
              iconClass: "fa-clock-o",
              col: 2
            },
            {
              title: ["结束时间", 'end time'],
              data: data.conference.cEnd,
              iconClass: "fa-clock-o",
              col: 1
            },
            {
              title: ["会议地点", 'address'],
              data: data.conference.cProvince + " " + data.conference.cCity + " " + data.conference.cAddress,
              iconClass: "fa-map-marker",
              col: 1
            },
            {
              title: ["主办方", "Organizers"],
              data: data.conference.cOrg,
              iconClass: "fa-home",
              col: 1
            }
          ];
          this.oProvince = [
            {
              title: ["报名类型", "Registration type"],
              data: data.conference.cPrice + "元",
              iconClass: "fa-money",
              col: 2
            },
          ];
          this.cContent = data.conference.cContent;
          this.cGuide = data.conference.cGuide;
          this.cCalendar = data.conference.cCalendar;
          this.news = data.template.navs.map((item, index) => {
//            if(item.)
            return item;
            if (item.navSys === 'info' && item.infos) {
              return item.infos;
            }
          })

        }).catch((error) => {
          console.log(error);
        });
//      axios.post('/medapp/api/con/detail', {
//        cid: 11,
//        uid: 11
//      })
//      .then((response)=>{
//
//      })
//      .catch(function (error) {
//        console.log(error);
//      });
      },
      scanClick(value){
        this.activeScan = value;
      },
      toggle(){
        this.activeScan = !this.activeScan;
      },
      login(){
        this.showLogin = true;
      },
      loginUser(user){
        this.showLogin = false;
        console.log(user);
        this.author = user.phone;
//    保存user信息
        localStorage.setItem('user', JSON.stringify(user));
        axios.post('/medapp/api/con/detail', {
          cid: 11,
          uid: user.uId
        })
          .then((response) => {
            let data = response.data;
            console.log("--------查看是否报名------------")
            console.log(data);
            if (data.register === null) {
              this.bmText = "点击报名"
            } else {
              this.bmText = "查看报名信息"
            }
          })
      },
      closeLogin(){
        this.showLogin = false;
      },
      changeLang(value){
        this.language = value;
      }
    },
    watch: {
      language(value){
        this.language = value;
        let lang = 'cn';
        if (value === 1) {
          lang = "en"
        }
        console.log("语言改变了");
        this.initData(lang);
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .container {
    width: 985px;
    margin: 0 auto;
    margin-top: 18px;
    font-size: 18px;
  }

  .box-list {
    padding: 20px;
  }

  .baoming {
    position: absolute;
    left: 0;
    bottom: 40px;
    text-align: center;
    z-index: 10;
    width: 100%;
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// index.vue?1a305ab6